import "./ServicesAdmin.scss";
import { useState } from "react";
import {
  Button,
  Grid,
  Input,
  Loader,
  Menu,
  MenuItem,
  Segment,
} from "semantic-ui-react";
import DetalleBeneficiarioMista from "./components/DetalleBeneficiarioMista";
import MistaService from "../../../../services/Mista";

const BeneficiariosMista = () => {
  const [dni, setDni] = useState("");
  const [beneficiario, setBeneficiario] = useState("");
  const [loading, setLoading] = useState(false);

  const puedesBuscar = dni.trim() !== "";

  async function obtenerBeneficiario() {
    setLoading(true);
    setBeneficiario(await MistaService.obtenerBeneficiario(dni));
    setLoading(false);
  }

  return (
    <>
      <h1>Beneficiarios Mista</h1>

      <Segment>
        <h3>Buscador</h3>
        <Menu tabular>
          <MenuItem name="Por Documento" active />
        </Menu>

        <Segment
          attached="bottom"
          style={{ overflow: "visible", minHeight: "110px" }}
        >
          <Grid>
            <Grid.Row>
              <Grid.Column mobile={16} tablet={8} computer={6}>
                <label>DNI del beneficiario</label>
                <br />
                <Input
                  style={{ marginTop: "5px", marginRight: "10px" }}
                  placeholder="Ej: 22360415"
                  value={dni}
                  onChange={(e) => setDni(e.target.value)}
                  onKeyDown={(e) =>
                    e.key === "Enter" &&
                    puedesBuscar &&
                    !loading &&
                    obtenerBeneficiario()
                  }
                />
                <Button
                  style={{ minWidth: "100px" }}
                  disabled={loading || !puedesBuscar}
                  onClick={obtenerBeneficiario}
                >
                  {loading ? <Loader active inline size="mini" /> : "Buscar"}
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </Segment>

      <DetalleBeneficiarioMista beneficiario={beneficiario} />
    </>
  );
};

export default BeneficiariosMista;
